import { jsx as n, jsxs as d, Fragment as l } from "react/jsx-runtime";
import { d as i, aW as y } from "../../vendor-EQDp64ng.js";
import { forwardRef as f } from "react";
import { stupidInvertClasses as b } from "../../utils/index.js";
import { getButtonStyles as h } from "../BaseButton/index.js";
import { BaseIcon as u } from "../BaseIcon/index.js";
import { isIconName as B } from "../BaseIcon/typeGuards.js";
import { withTooltip as z } from "../Tooltip/withTooltip.js";
import { omitStyleRenderProps as k } from "../../utils/omitStyleRenderProps/index.js";
import '../../assets/index62.css';const x = "_toggleButton_gpayz_1", $ = "_secondary_gpayz_10", I = "_heart_gpayz_18", L = "_pin_gpayz_19", T = "_bookmark_gpayz_20", j = "_star_gpayz_21", v = "_sm_gpayz_52", w = "_hasLabel_gpayz_52", N = "_md_gpayz_56", t = {
  toggleButton: x,
  secondary: $,
  heart: I,
  pin: L,
  bookmark: T,
  star: j,
  sm: v,
  hasLabel: w,
  md: N
}, E = z(
  f(
    ({
      size: s = "md",
      variant: o = "secondary",
      __inverted: m,
      children: a,
      icon: c,
      ...r
    }, _) => {
      const p = i(
        h({
          size: s,
          variant: o === "secondary" ? "secondary" : "ghost",
          ...r
        }),
        t.toggleButton,
        a ? t.hasLabel : void 0,
        t[o],
        t[s],
        m ? b() : void 0
      );
      return /* @__PURE__ */ n(
        y,
        {
          ...k(r),
          className: p,
          ref: _,
          "data-component": "ToggleButton",
          children: ({ isSelected: g }) => {
            const e = o === "secondary" ? c : `${o}${g ? "-filled" : ""}`;
            return /* @__PURE__ */ d(l, { children: [
              B(e) && /* @__PURE__ */ n(u, { icon: e, size: s }),
              a
            ] });
          }
        }
      );
    }
  )
);
export {
  E as ToggleButton
};
